import sc from 'styled-components';


export const PaginationWrapper = sc.div`
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;
    margin: 8px 0;
`;

export const PaginationButton = sc.button<{$selected?: boolean; $shape?: string; $variant?: string}>`
    min-width: 32px;
    height: 32px;
    border-radius: ${({$shape}) => ($shape === 'rounded' ? '16px' : '4px')};
    border: ${({$variant, $selected}) =>
		$variant === 'outlined'
			? $selected
				? '2px solid #001B74'
				: '1px solid #001B74'
			: 'none'};
    background: ${({$selected}) => ($selected ? '#001B74' : '#fff')};
    font-weight: ${({$selected}) => ($selected ? 'bold' : 'normal')};
    cursor: pointer;
    transition: background 0.2s, color 0.2s, border 0.2s;
    outline: none;

    &:hover {
        background: #e0e0e0;
        color: #001B74;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;